import { RdowizardStepType } from "../../type";
import { BrowserFile } from "./steps/browserFile";
import { ReviewAndUpload } from "./steps/reviewAndUpload";
import { FunctionSelection } from "./FunctionSelection";
import { SheetMap } from "./steps/functionMap";

const Container = (props: any) => {
    const {
        app,
        currentStep,
        fileUpload,
        onFileUpdate,
        refresh,
        onFileUpdateRefresh,
        api,
        closeAddUpdate,
        isUpdate,
        selectedFunction,
        selectedFunctions,
        setSelectedFunctions,
        formData,
        setFormData,
        onValidateStep
    } = props;

    return (
        <div className="wizard-container">
            {currentStep === RdowizardStepType.BrowserFile && (
                <BrowserFile
                    fileUpload={fileUpload}
                    onFileUpdate={onFileUpdate}
                    onFileUpdateRefresh={onFileUpdateRefresh}
                />
            )}

            {currentStep === RdowizardStepType.FunctionMap && (
                <SheetMap
                    fileUpload={fileUpload}
                    onFileUpdate={onFileUpdate}
                    refresh={refresh}
                    selectedFunction={selectedFunction}
                    app={app}
                />
            )}

            {currentStep === RdowizardStepType.SheetMap && (
                <FunctionSelection
                    api={api}
                    closeAddUpdate={closeAddUpdate}
                    selectedFunctions={selectedFunctions}
                    setSelectedFunctions={setSelectedFunctions}
                    onValidate={(validateFn: () => boolean) => onValidateStep(currentStep, validateFn)}
                />
            )}

            {currentStep === RdowizardStepType.ReviewAndUpload && (
                <ReviewAndUpload
                    fileUpload={fileUpload}
                    app={app}
                    api={api}
                    isUpdate={isUpdate}
                    selectedFunction={selectedFunction}
                    selectedFunctions={selectedFunctions}
                    closeAddUpdate={closeAddUpdate}
                    formData={formData}
                    setFormData={setFormData}
                />
            )}
        </div>
    );
};

export { Container };